import { render } from "./cu-table.vue?vue&type=template&id=6d89d540"
import script from "./cu-table.vue?vue&type=script&lang=js"
export * from "./cu-table.vue?vue&type=script&lang=js"

import "./cu-table.vue?vue&type=style&index=0&id=6d89d540&lang=css"

import exportComponent from "/Users/kexikui/Desktop/code/dlmk/delemick-pc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__